import { render, staticRenderFns } from "./TimerControl.vue?vue&type=template&id=4b2d256d&scoped=true"
import script from "./TimerControl.vue?vue&type=script&lang=js"
export * from "./TimerControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d256d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b2d256d')) {
      api.createRecord('4b2d256d', component.options)
    } else {
      api.reload('4b2d256d', component.options)
    }
    module.hot.accept("./TimerControl.vue?vue&type=template&id=4b2d256d&scoped=true", function () {
      api.rerender('4b2d256d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/controls/TimerControl.vue"
export default component.exports